import React, { Component } from "react";
import { Paper, withStyles } from '@material-ui/core';
import { Button, Row, Col, Form } from 'react-bootstrap';
import { Query, withApollo } from "react-apollo";
import InputMask from 'react-input-mask';
import { layoutsVideoQuery, salvarGravacaoVideo } from '../../../graphql/Gravacao';
import Swal from 'sweetalert2';
import moment from 'moment-timezone';

const classes = theme => ({
    button: {
        margin: theme.spacing(1),
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
    root: {
        padding: theme.spacing(3, 2),
        minHeight: 470,
        width: '30vw'
    },
    paper: {
        display: 'flex',
        flexDirection: 'column',
    },
    footerWrapper: {
        display: 'flex',
        flexDirection: 'row-reverse',
        justifyContent: 'space-between'
    },
    footer: {
        marginTop: 'auto'
    },
    titulo: {
        fontSize: '25px'
    },
    subtitulo: {
        marginTop: '25px',
        marginBottom: '25px',
        fontSize: '20px'
    },
    modalListLine: {
        marginBottom: '2em',
        '&:first-child': {
            paddingTop: '20px'
        }
    },
    modalListLineTitle: {
        fontWeight: 'bold',
        fontSize: '14px'
    },
    modalListLineData: {
        fontSize: '14px',
        paddingLeft: '10px !important',
        paddingRight: '10px !important'
    },
    buttonsActionWrapper: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: '0px !important',
    },
    footerButtons: {
        marginBottom: '0px !important',
    },
    trechoListItem: {
        marginBottom: '10px !important'
    }
});

class GravacaoNovoVideo extends Component {
    constructor(props) {
        super(props)
    
        this.state = {
            nome: '',
            layout: 1,
            duracao: 0,
            trechos: [],
            addIntervaloInicio: '',
            addIntervaloFim: ''
        }

        this.formInputNomeOnChange = this.formInputNomeOnChange.bind(this);
        this.formInputLayoutOnChange = this.formInputLayoutOnChange.bind(this);
        this.formInputDuracaoOnChange = this.formInputDuracaoOnChange.bind(this);
        this.buttonAddTrechoClickHandle = this.buttonAddTrechoClickHandle.bind(this);
        this.adicionarGravacao = this.adicionarGravacao.bind(this);
        this.buttonRemoveTrechoClickHandle = this.buttonRemoveTrechoClickHandle.bind(this);
        this.addTrechoInicioChangeHandle = this.addTrechoInicioChangeHandle.bind(this);
        this.addTrechoFimChangeHandle = this.addTrechoFimChangeHandle.bind(this);
        this.validateTime = this.validateTime.bind(this);
    }

    render() {
        return (
            <Query query={layoutsVideoQuery} fetchPolicy='network-only'>
                {({ data, loading, error, refetch }) => {
                    if (loading) return 'Loading...'
                    if (error) return `Error! ${error.message}`
                    this._queryRefetch = refetch;

                    const { layoutVideoList } = data;
                    const { nome, layout, duracao, trechos, addIntervaloInicio, addIntervaloFim } = this.state;
                    const { classes, handleCloseFnc, gravacaoData } = this.props;

                    const layoutOptions = layoutVideoList.map( el => {
                        return (
                            <option value={el.id} key={el.id}>{el.nome}</option>
                        );
                    });

                    const listaTrechos = trechos.map( (el, idx) => {
                        return (
                            <Form.Group as={Form.Row} key={idx} className={classes.trechoListItem}>
                                <Col md={{offset: 4, span: 3}}>
                                    <InputMask value={el.inicio} onChange={ event => this.formInputTrechoInicioOnChange(event, idx) } className="form-control" placeholder="hh:mm:ss" mask="99:99:99" maskChar=" "/>
                                </Col>
                                <Col md="3">
                                    <InputMask value={el.fim} onChange={ event => this.formInputTrechoFimOnChange(event, idx) } className="form-control" placeholder="hh:mm:ss" mask="99:99:99" maskChar=" "/>
                                </Col>
                                <Col md="2">
                                    <Button type="button" onClick={ () => this.buttonRemoveTrechoClickHandle(idx) } className="btn btn-danger">-</Button>
                                </Col>
                            </Form.Group>
                        );
                    });

                    const addTrechos = (
                        <Form.Group as={Form.Row} className={classes.trechoListItem}>
                            <Col md={{offset: 4, span: 3}}>
                                <InputMask value={addIntervaloInicio} onChange={ this.addTrechoInicioChangeHandle } className="form-control" placeholder="hh:mm:ss" mask="99:99:99" maskChar=" "/>
                            </Col>
                            <Col md="3">
                                <InputMask value={addIntervaloFim} onChange={ this.addTrechoFimChangeHandle } className="form-control" placeholder="hh:mm:ss" mask="99:99:99" maskChar=" "/>
                            </Col>
                            <Col md="2">
                                <Button type="button" onClick={ this.buttonAddTrechoClickHandle }>+</Button>
                            </Col>
                        </Form.Group>
                    );

                    return (
                        <Paper className={`${classes.root} ${classes.paper}`}>
                            <Form.Group as={Form.Row}>
                                <Col md="3" className={classes.modalListLineTitle}>
                                    <Form.Label htmlFor="inputVideoNome">Nome</Form.Label>
                                </Col>
                                <Col md="6" className={classes.modalListLineData}>
                                    <Form.Control defaultValue={nome} onChange={this.formInputNomeOnChange} id="inputVideoNome" placeholder="Nome do vídeo"></Form.Control>
                                </Col>
                            </Form.Group>

                            <Form.Group as={Form.Row}>
                                <Col md="3" className={classes.modalListLineTitle}>
                                    <Form.Label htmlFor="selectVideoLayout">Layout</Form.Label>
                                </Col>
                                <Col md="8" className={classes.modalListLineData}>
                                    <Form.Control as="select" onChange={this.formInputLayoutOnChange} id="selectVideoLayout">
                                        {layoutOptions}
                                    </Form.Control>
                                </Col>
                            </Form.Group>

                            <Form.Group as={Form.Row}>
                                <Col md="3" className={classes.modalListLineTitle}>
                                    <Form.Label htmlFor="duracaoCompleto">Duração</Form.Label>
                                </Col>
                                <Col md="6" className={classes.modalListLineData}>
                                    <Form.Check type="radio" label="Completo" name="radioButtonDuracao" id="duracaoCompleto" onChange={this.formInputDuracaoOnChange} value="0"/>
                                    <Form.Check type="radio" label="Partes" name="radioButtonDuracao" id="duracaoPartes" onChange={this.formInputDuracaoOnChange} value="1"/>
                                </Col>
                            </Form.Group>

                            { duracao == '1' ? listaTrechos : null }
                            { duracao == '1' ? addTrechos : null }

                            <Form.Group as={Form.Row} className={classes.footer}>
                                <Col md="12" className={classes.buttonsActionWrapper}>
                                    <Button onClick={handleCloseFnc} variant="secondary" className={`btn-close btn-sm btn-primary-get ${classes.footerButtons}`}>Cancelar</Button>
                                    <Button onClick={this.adicionarGravacao} variant="secondary" className={`btn-close btn-sm btn-primary-get ${classes.footerButtons}`}>Adicionar</Button>
                                </Col>
                            </Form.Group>
                        </Paper>
                    )
                }}
            </Query>
        );
    }

    formInputNomeOnChange(event) {
        this.setState({
            nome: event.target.value
        });
    }

    formInputLayoutOnChange(event) {
        this.setState({
            layout: event.target.value
        });
    }

    formInputDuracaoOnChange(event) {
        this.setState({
            duracao: event.target.value
        });
    }

    formInputTrechoInicioOnChange(event, idx) {
        const { trechos } = this.state;
        trechos[idx].inicio = event.target.value;
        this.setState({ trechos: trechos });
    }

    formInputTrechoFimOnChange(event, idx) {
        const { trechos } = this.state;
        trechos[idx].fim = event.target.value;
        this.setState({ trechos: trechos });
    }

    addTrechoInicioChangeHandle(event) {
        this.setState({
            addIntervaloInicio: event.target.value
        });
    }

    addTrechoFimChangeHandle(event) {
        this.setState({
            addIntervaloFim: event.target.value
        });
    }

    buttonAddTrechoClickHandle() {
        const { addIntervaloInicio, addIntervaloFim } = this.state;
        let { trechos } = this.state;

        if (!addIntervaloInicio || !addIntervaloFim) {
            return;
        }

        // Validar inicio e fim individualmente
        if ( !this.validateTime(addIntervaloInicio) || !this.validateTime(addIntervaloFim) ) {
            return;
        }

        // Validar se fim é maior que início
        const trechoInicioSplit = addIntervaloInicio.split(':');
        const trechoFimSplit = addIntervaloFim.split(':');
        let temErro = false;
        let mensagemErro = '';

        // primeiro validar hora
        const horaIni = parseInt(trechoInicioSplit[0]);
        const horaFim = parseInt(trechoFimSplit[0]);
        const minIni = parseInt(trechoInicioSplit[1]);
        const minFim = parseInt(trechoFimSplit[1]);
        const secIni = parseInt(trechoInicioSplit[2]);
        const secFim = parseInt(trechoFimSplit[2]);
        // console.log('HORA', horaIni, horaFim);

        if ( horaIni > horaFim ) {
            temErro = true;
            mensagemErro = "Início maior do que final";
        }

        if ( !temErro && ( horaIni == horaFim ) ) {
            // console.log('MINUTO', minIni, minFim);
            if ( minIni > minFim ) {
                temErro = true;
                mensagemErro = "Início maior do que final";
            }

            if ( !temErro && ( horaIni == horaFim ) ) {
                // console.log('SEGUNDOS', secIni, secFim);
                if ( secIni > secFim ) {
                    temErro = true;
                    mensagemErro = "Início maior do que final";
                }
            }
        }

        const addTrechoInicioMoment = moment('2020-01-01T'+addIntervaloInicio+'Z').unix();
        const addTrechoFimMoment = moment('2020-01-01T'+addIntervaloFim+'Z').unix();

        for ( let idx = 0; idx <= trechos.length-1; idx++) {
            const iterationInicioMoment = moment('2020-01-01T'+trechos[idx].inicio+'Z').unix();
            const iterationFimMoment = moment('2020-01-01T'+trechos[idx].fim+'Z').unix();

            if ( addTrechoInicioMoment <= iterationFimMoment && addTrechoFimMoment >= iterationInicioMoment ) {
                temErro = true;
                mensagemErro = 'Existe sobreposição de intervalos';
                break;
            }
        }

        if (temErro) {
            Swal.fire({
                title: "Intervalo com problemas",
                text: mensagemErro,
                icon: "error",
                confirmButtonColor: "#ff0000",
                showCancelButton: false,
            });
            return;
        }

        // Converter tempos para segundos
        const nvl = (n1,n2) => {
            if (n1) return n1;
            return n2;
        }

        const inicioSegundos = (nvl(horaIni, 0) * 60 * 60) + (nvl(minIni,0) * 60) + secIni;
        const fimSegundos = (nvl(horaFim, 0) * 60 * 60) + (nvl(minFim,0) * 60) + secFim;

        const novoTrecho = {
            inicio: addIntervaloInicio,
            fim: addIntervaloFim,
            inicio_segundos: inicioSegundos,
            fim_segundos: fimSegundos
        };

        console.log('NOVO TRECHO: ', novoTrecho);
        trechos.push(novoTrecho);

        trechos.sort( (a,b) => {
            if (a.inicio < b.inicio) return -1;
            if (a.inicio > b.inicio) return 1;
            return 0;
        });

        this.setState({
            trechos,
            addIntervaloInicio: '',
            addIntervaloFim: '',
         });
    }

    validateTime(val) {
        const valSplit = val.split(':');

        const throwSwal = message => {
            Swal.fire({
                title: "Intervalo com problemas",
                text: message,
                icon: "error",
                confirmButtonColor: "#ff0000",
                showCancelButton: false,
            });
        }

        if (valSplit.length != 3) {
            throwSwal('Preencher corretamente!');
            return false;
        }

        const hours = valSplit[0];
        if (hours < 0) {
            throwSwal(`Horário ${val} inválido`);
            return false;
        }

        const minutes = valSplit[1];
        if ( minutes >= 60 || minutes < 0) {
            throwSwal(`Horário ${val} inválido`);
            return false;
        }

        const seconds = valSplit[2];
        if ( seconds && ( seconds >= 60 || seconds < 0 )) {
            throwSwal(`Horário ${val} inválido`);
            return false;
        }

        const formatCheck = moment('2020-01-01T'+val+'Z').utc().format('HH:mm:ss');
        if (formatCheck != val) {
            throwSwal(`Horário ${val} inválido`);
            return false;
        }

        return true;
    }

    buttonRemoveTrechoClickHandle(idx) {
        let { trechos: stateTrechos } = this.state;
        stateTrechos.splice(idx, 1);
        this.setState({
            trechos: stateTrechos
        });
    }

    adicionarGravacao() {
        const { client, gravacaoData } = this.props;
        const { nome, layout, duracao, trechos } = this.state;

        if (!nome || !duracao) {

            const emptyField = !nome ? 'Nome' : 'Duração';

            Swal.fire({
                title: "Dados incompletos",
                text: `Favor preencher o campo "${emptyField}"`,
                icon: "error",
                confirmButtonColor: "#ff0000",
                showCancelButton: false,
            });
            return;
        }

        if ( duracao == 1 && trechos.length == 0 ) {
            Swal.fire({
                title: "Dados incompletos",
                text: "Preencha os intervalos para gerar o vídeo",
                icon: "error",
                confirmButtonColor: "#ff0000",
                showCancelButton: false,
            });
            return;
        }

        const trechosValidado = trechos.filter( el => el.inicio && el.fim );
        const trechosJson = duracao == 1 ? JSON.stringify(trechosValidado) : '';

        const saveObj = {
            gravacao_bbb_id: gravacaoData.gravacao.id,
            sessao_id: gravacaoData.parentSession.id,
            inicio: gravacaoData.gravacao.inicio,
            nome,
            layout_video_id: layout,
            fl_partes: duracao,
            json_partes: trechosJson
        };

        client.mutate({
            mutation: salvarGravacaoVideo,
            variables: saveObj
        }).then(data => {
            const { handleCloseFnc, atualizarTabelaVideosFnc } = this.props;
            if (atualizarTabelaVideosFnc) {
                atualizarTabelaVideosFnc();
            }
            handleCloseFnc();
            Swal.fire({
                title: "Video Adicionado!",
                text: "Video adicionado com sucesso",
                icon: "success",
                confirmButtonColor: "#5d5d5d",
                showCancelButton: false,
            });
        }).catch(ex => {
            const errorMessage = ex.graphQLErrors.map(e => e.debugMessage).join("\n");
            Swal.fire({
                title: "Erro ao adicionar video",
                text: errorMessage || "",
                icon: "error",
                confirmButtonColor: "#ff0000",
                showCancelButton: false,
            });
        });
    }

}

export default withStyles(classes)(withApollo(GravacaoNovoVideo));